import { IClientEnv } from "api/server/clientEnv";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "./store";

interface IEvnState {
  value: IClientEnv;
}

const initialState: IEvnState = {
  value: {
    NODE_ENV: "",
    SERVER_URL: "",
    AUTH_SERVER: "",
    MGR_SERVER: "",
    UCWORKS_VER: "",
    CLOUD_CONVERT_APIKEY: "",
    IS_PRIVATE_NETWORK: false,
    USE_DOC_SHARING: true,
    USE_SCREEN_SHARING: true,
    USE_SCREEN_SHOT: true,
    USE_RECORDING: true,
    USE_STT: true,
    USE_MEMO: true,
    USE_EXTERNAL_PARTICIPANT: true,
    FORCE_VIRTUAL_BG: false,
    MAX_DISPLAY_USERS_IN_GRID: 30,
    ENABLE_NOISE_SUPPRESSION: false,
    ENABLE_ECHO_CANCELLATION: false,
    ENABLE_AUTO_GAIN_CONTROL: false,
  },
};

export const envSlice = createSlice({
  name: "env",
  initialState,
  reducers: {
    setEnv: (state: IEvnState, action: PayloadAction<IClientEnv>) => {
      state.value = { ...action.payload };
    },
  },
});

export const { setEnv } = envSlice.actions;

export const selectEnv = (state: RootState) => state.env.value;

export default envSlice.reducer;
